// extracted by mini-css-extract-plugin
export var tag = "tag-module--tag--4vrlp";
export var toggleTag = "tag-module--toggleTag--oYmNk";
export var toggleTagActive = "tag-module--toggleTag--active--xlkRB";
export var wideTag = "tag-module--wide-tag--lPb+N";